var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stream-comment--wrapper" },
    [
      _c("h4", { staticClass: "stream-comment--title" }, [
        _vm._v("комментарии к подзадаче"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-text stream-comment--window" },
        [
          _vm._l(_vm.comments, function (comment) {
            return _c(
              "div",
              {
                staticClass: "stream-comment",
                attrs: { set: (_vm.user = _vm.getUser(comment.userId)) },
              },
              [
                _c("div", { staticClass: "stream-comment__date" }, [
                  _vm._v(_vm._s(_vm.toDate(comment.date))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "stream-comment__user",
                    style: { color: _vm.userColor[_vm.user.id] },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.user.name))])]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "stream-comment__text" }, [
                  _vm._v(_vm._s(comment.text)),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.comments.length && !_vm.isAccessAllow
            ? _c("p", [_vm._v("комментариев нет")])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isAccessAllow || _vm.current_user.id in _vm.common_users_list
        ? [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.newCommentText,
                  expression: "newCommentText",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "form-text stream-comment--input",
              attrs: { placeholder: "текст комментария" },
              domProps: { value: _vm.newCommentText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.newCommentText = $event.target.value.trim()
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "stream-comment--submit btn btn-primary",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onSubmit.apply(null, arguments)
                  },
                  keypress: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onSubmit.apply(null, arguments)
                  },
                },
              },
              [_vm._v("Отправить")]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }